<template>
    <div class="Top-top">
        <div class="Top-top-content">
            <div class="Top-top-logo" v-show="logoShow">
                <img v-if="topOne" src="../../static/webp1/barlogo.png" class="logo" alt="" />
                <img v-else class="logo" :src="this.imgLogo" alt="" />
            </div>
            <div class="Top-top-line"></div>
            <div class="Top-top-text">{{ this.title }}</div>
            <div v-if="false" class="Top-top-register" @click="showRegisterModal">
                <img src="../../static/webp1/supplier-register.png" alt="">
                <span class="register-text">供应商注册</span>
                <registerModal ref="registerModal" />
            </div>
             <!-- 新增右下角文字 -->
            <div class="world-peace">公开  公平  公正  诚实信用</div>
        </div>
       
    </div>
</template>

<script>
import registerModal from "./register-modal";
import casjump from "../common/casjump";
import axios from "axios";
export default {
    data() {
        return {
            isLogin: false,
            loginName: "",
            currentUser: {},
            perShow: false,
            title: "",
            logoShow: false,
            imgLogo: "",
            topOne: true,
        };
    },
    inject: ["reload"],
    mixins: [casjump],
    components: { registerModal },
    mounted() {
        this.getPerson();
        if (sessionStorage.getItem("person")) {
            let data = JSON.parse(sessionStorage.getItem("person"));
            this.isLogin = true;
            this.currentUser.name = data;
        }
        this.getLogo();
    },
    methods: {
        showRegisterModal() {
            this.$refs.registerModal.showModal();
        },
        qiehuan() {
            sessionStorage.removeItem("cmsInfo");
            this.$router.push("/Portal");
            this.reload();
        },
        toLogin() {
            this.$router.push("/login");
        },
        loginout() {
            if (window.osConfig.ossUrl) {
                GMS.util.nros
                    .getPlugin("login")
                    .logout()
                    .then((res) => {
                        localStorage.removeItem("TGT");
                        sessionStorage.removeItem("person");
                        window.location.href = window.location.origin;
                    });
            } else {
                let config = {
                    method: "get",
                    url: `${window.osConfig.baseUrl}/nvwa/logout`,
                    headers: {
                        Authorization: localStorage.getItem("_token"), //设置token 其中K名要和后端协调好
                    },
                };
                axios(config)
                    .then(function (response) {
                        if (response.status == 200) {
                            localStorage.removeItem("TGT");
                            sessionStorage.removeItem("person");
                            window.location.href = window.location.origin;
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        },
        getPerson() {
            GMS.vbus.$on("logininfo", (data) => {
                this.isLogin = true;
                this.currentUser = data;
                sessionStorage.setItem("person", JSON.stringify(data.name));
            });
        },
        cover() {
            this.perShow = true;
        },
        leave() {
            this.perShow = false;
        },
        personShow() {
            this.perShow = true;
        },
        jump() {
            this.casjump(window.osConfig.staticService);
        },
        getLogo() {
            GMS.$http
                .get("/portal/logo/query")
                .then((res) => {
                    if (res.status == 200) {
                        this.title = res.data.title
                            ? res.data.title
                            : "招标采购信息网";
                        if (res.data.topOne) {
                            this.imgLogo = res.data.topOne;
                            this.topOne = false;
                        }
                    }
                    this.logoShow = true;
                })
                .catch((error) => {
                    this.title = "招标采购信息网";
                    this.logoShow = true;
                    this.$Message.error("获取数据异常，请联系管理员");
                });
        },
    },
};
</script>

<style lang="less" scoped>
.Top-top {
    width: 100%;
    height: 200px;
    padding: 0 15%;
    background-image: url("../../static/webp1/topbackground.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    position: relative;
    .banner-img {
        width: 100%;
        height: 100%;
        object-fit: cover; /* or: contain */
    }
    .world-peace {
        position: absolute;
        right: 50px;
        height: 100%;
        display: flex;
        align-items: center;
        font-size: 2.3vw;
        color: #ffffff;
        font-family: "SimHei", "黑体", sans-serif; /* 设置黑体 */
        font-weight: bold; /* 加粗 */
        text-shadow: 1px 1px 3px rgba(0,0,0,0.6); /* 防止白字背景看不清 */
        z-index: 2; /* 确保在背景图之上 */
    }
    .Top-top-content {
        // width: 1200px;
    }
    // @media screen and (max-width: 1500px) {
    //   .Top-top-content {
    //     width: 1200px;
    //   }
    // }
    // @media screen and (min-width: 1500px) and (max-width: 1800px) {
    //   .Top-top-content {
    //     width: 1400px;
    //   }
    // }
    // @media screen and (min-width: 1800px) {
    //   .Top-top-content {
    //     width: 1600px;
    //   }
    // }
    .Top-top-content {
        height: 200px;
        margin: 0 auto;
        display: flex;
        align-items: center;

        .Top-top-logo {
            float: left;
            width: 330px;
            height: 80px;
            // background: url("../../static/webp1/logo@2x.webp") no-repeat;
            // background-size: 330px 45px;
        }
        .logo {
            object-fit: fill;
            width: 100%;
            height: 100%;
        }
        .Top-top-line {
            float: left;
            margin-left: 20px;
            margin-right: 20px;
            width: 1px;
            height: 46px;
            background: #ffffff;
            opacity: 0.52;
            // margin-top: 42px;
        }
        .Top-top-text {
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 1.8vw;
            color: #ffffff;
        }
        .Top-top-login {
            position: relative;
            float: right;
            height: 25px;
            margin-right: 20px;
            line-height: 25px;
            color: #555555;
            margin-top: 42px;
            .top-login-name {
                cursor: pointer;
                font-weight: 400;
                font-size: 18px;
                color: #555555;
                letter-spacing: 0;
                float: left;
            }
            .top-login-line {
                // margin-left: 30px;
                margin-right: 25px;
                float: left;
                width: 1px;
                width: 1px;
                height: 20px;
                background: #d8d8d8;
                margin-top: 2px;
            }
            .top-login-qiehuan {
                margin-right: 50px;
                float: left;
                color: #555555;
                cursor: pointer;
            }
            .top-login-qiehuans {
                margin-right: 24px;
                float: left;
                color: #555555;
                cursor: pointer;
            }
            .top-login-logout {
                float: left;
                color: #555555;
            }
        }
        .Top-top-register {
            float: right;
            display: flex;
            align-items: center;
            width: 118px;
            justify-content: space-around;
            cursor: pointer;
            .register-text {
                font-family: PingFangSC-Regular;
                font-weight: 400;
                font-size: 18px;
                color: #555555;
                letter-spacing: 0.27px;
            }
        }
    }
}
.top-login-list {
    width: 88px;
    background: #ffffff;
    position: absolute;
    top: 20px;
    right: -15px;
    z-index: 5;
    box-shadow: 2px 2px 10px 0 rgba(0, 0, 0, 0.1);
    border-radius: 5px;
}
.a-icon {
    width: 23px;
    height: 23px;
    // margin-top: 3px;
    margin-right: 5px;
    background: url("../../static/img1/默认头像1.png") no-repeat;
    background-size: 23px 23px;
    float: left;
}
.text {
    cursor: pointer;
    float: left;
    // width: 20px;
    height: 20px;
    line-height: 20px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 18px;
    color: #015293;
    letter-spacing: 0.27px;
}
.nologin-icon {
    width: 23px;
    height: 23px;
    // margin-top: 3px;
    margin-right: 5px;
    background: url("../../static/img/20_DH_A_NW_切换@2x.png") no-repeat;
    background-size: 23px 23px;
    float: left;
}
.nologin-text {
    float: left;
    // width: 20px;
    height: 20px;
    line-height: 20px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 18px;
    color: #555555;
    letter-spacing: 0.27px;
}
.login-icon {
    width: 23px;
    height: 23px;
    // margin-top: 3px;
    margin-right: 5px;
    background: url("../../static/img1/默认头像.png") no-repeat;
    background-size: 23px 23px;
    float: left;
}
.login-text {
    float: left;
    // width: 20px;
    margin-right: 5px;
    height: 20px;
    line-height: 20px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 18px;
    color: #555555;
    letter-spacing: 0.27px;
}
.login-xiala {
    cursor: pointer;
    float: left;
    width: 18px;
    height: 20px;
    margin-top: 2px;
    background: url("../../static/img1/下拉.png") no-repeat;
    background-size: 20px 18px;
}
.list-text {
    height: 34px;
    line-height: 34px;
    text-align: center;
}
.list-text:hover {
    cursor: pointer;
    background: #ebf1f6;
    color: #005791;
}

</style>



// WEBPACK FOOTER //
// src/components/top.vue